/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgReceivingBox = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M11.47 2.152a1 1 0 0 1 1.06 0l8 5A1 1 0 0 1 21 8v8a1 1 0 0 1-.47.848l-8 5a1 1 0 0 1-1.06 0l-.399-.25v-5.063h-.07v-2.98l-6-3.75v2.831l-.172-.172L3 14.293V8a1 1 0 0 1 .47-.848zM13 19.196l6-3.75V9.804l-6 3.75zm-1-7.375L18.113 8 12 4.18 5.887 8z" />
        <path d="M4.414 20.536h4.657v-2H4.414l1.829-1.829-1.414-1.414-4.243 4.243 4.243 4.242 1.414-1.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgReceivingBox as ReceivingBox };
